import lookups from "./lookups";
import { AccessControlProviderFormStages } from "./accessControlProvider";
import { PastYearsSelectHeader } from "../components/elements/_Elements";

export const AccessControlProvidersFormStages = [
  {
    title: "Access Control Providers",
    sections: [
      {
        name: "",
        table: {
          allowAdd: true,
          allowEdit: true,
          allowStatusEdit: true,
          fields: [
            {
              name: "g4b_provider",
              className: "col-name",
            },
            {
              name: "g4b_sendcontacts",
              className: "col-bool",
            },
            {
              name: "g4b_sendevents",
              className: "col-bool",
            },
            {
              name: "g4b_sendprofilephoto",
              className: "col-bool",
            },
            {
              name: "g4b_sendtelegrams",
              className: "col-bool",
            },
            {
              name: "createdon",
              className: "col-date",
              type: "datetime",
            },
            {
              name: "modifiedon",
              className: "col-date",
              type: "datetime",
            },
          ],
          filterByStatus: true,
          filters: [
            {
              textFieldsSearch: ["Name"],
              type: "text",
            },
            {
              name: "createdon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
            {
              name: "modifiedon",
              renderCustomHeader: PastYearsSelectHeader,
              type: "datetime",
            },
          ],
          linkForNewRecord: "/access-control-provider",
          lookup: lookups.g4b_accesscontrolprovider.all,
          subFormStages: AccessControlProviderFormStages,
          useAlphabetPagination: true,
          useSubForm: false,
        },
      },
    ],
  },
];
